import { Button } from "@component-ui/utility/Button";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@component-ui/utility/Tooltip";
import useSoftDeleteMeetingMutate from "@hooks/meeting/useSoftDeleteMeetingMutate";
import { Loader, Trash } from "lucide-react";
import { FC } from "react";

type SoftDeleteMeetingButtonProps = {
    id: string;
};

const SoftDeleteMeetingButton: FC<SoftDeleteMeetingButtonProps> = ({ id }) => {
    const { mutateAsync: deleteMeeting, isPending } = useSoftDeleteMeetingMutate();

    return (
        <TooltipProvider delayDuration={200}>
            <Tooltip>
                <TooltipTrigger asChild>
                    <Button
                        variant="ghost"
                        size="icon"
                        onClick={(e) => {
                            e.stopPropagation();
                            deleteMeeting(id);
                        }}
                    >
                        {isPending ? (
                            <Loader className="animate-spin" />
                        ) : (
                            <Trash />
                        )}
                    </Button>
                </TooltipTrigger>
                <TooltipContent side="bottom">Delete meeting</TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};

export default SoftDeleteMeetingButton;
